var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{attrs:{"flat":""}},[_vm._l((_vm.components),function(component,key){return [_c(component,{tag:"component",attrs:{"items":_vm.data[key]},on:{"editSetting":_vm.handleChildEditSetting,"addSetting":function($event){return _vm.$emit('addSetting', $event)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }